import * as React from "react";

export const EmptyElement: React.FC = () => (
  <div className="map-element map-element--empty" />
);
;
import "/Users/igor/Duffel/duffel-components/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";